module.exports = __webpack_public_path__ + "img/jg7.8216ba8c.png";